import { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import useDebounce from '@spa/hooks/useDebounce';

interface SearchBarProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  clearIconClassName?: string;
}

function Searchbar({
  value = '',
  onChange,
  placeholder = 'Search',
  className = '',
  clearIconClassName = 'text-muted-foreground hover:text-primary-text',
}: SearchBarProps) {
  const [search, setSearch] = useState(value);
  const debouncedValue = useDebounce<string>(search, 250);

  useEffect(() => {
    onChange(search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  return (
    <div className={className}>
      <div className="relative h-full">
        <SearchIcon
          fontSize="small"
          className="absolute left-2.5 top-1/2 -translate-y-1/2 size-6"
        />
        <input
          type="text"
          placeholder={placeholder}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="
          bg-white w-full
          h-full
          pl-10 pr-10 py-3
          border border-biomar-border rounded-md
          text-sm text-primary-text 
          placeholder:text-muted-foreground
          focus:outline-none focus:ring-1
        "
        />
        {search.length > 0 && (
          <ClearIcon
            onClick={() => {
              setSearch('');
              onChange('');
            }}
            className={`absolute right-2.5 top-1/2 -translate-y-1/2 cursor-pointer ${clearIconClassName}`}
            fontSize="small"
          />
        )}
      </div>
    </div>
  );
}

export default Searchbar;
